export default __webpack_public_path__ + "static/media/propoagate-logomark-icon-green.4d828490.svg";